const SAVE_FEEDBACK_EVENT = "app:save-feedback";

export function emitSaveFeedback(detail) {
  window.dispatchEvent(new CustomEvent(SAVE_FEEDBACK_EVENT, { detail }));
}

export function onSaveFeedback(listener) {
  function handleEvent(event) {
    listener(event.detail ?? {});
  }

  window.addEventListener(SAVE_FEEDBACK_EVENT, handleEvent);
  return () => window.removeEventListener(SAVE_FEEDBACK_EVENT, handleEvent);
}
